import React from 'react'
import "../../Styles/totalViewHours.scss"
import refresh from "../../Assests/icons/refresh.png"
export default function TotalViewHours({ title, value, percentage, description, icon }) {
    return (
        <div className="stat-card">
          <div className="stat-card-header">
            <h3 className="stat-title">{title}</h3>
            <div className="stat-icon">{icon}</div>
          </div>
          <div className="stat-card-body">
            <p className="stat-value">{value}</p>

          </div>
        </div>
      );
}
export function RefreshTime({ value }) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Change to false for 24-hour format
    };
    return date.toLocaleDateString("en-US", options);
  };

  return (
    <div className="stat-RefreshTime">
      <div>
      <img src={refresh}/>
      </div>
      <div className='refresh-text'>
      The data refresh occurred on
      <br />
      <span className='refresh-date'>{formatDate(value)}</span>
      </div>   
    </div>
  );
}

